export default __webpack_public_path__ + "static/yellow_dots2-a39be29ec0f388d93c0eab5ecd5ed211.svg";